export default __webpack_public_path__ + "static/media/logoM.1d49af2b.svg";